/* DN: UGC-Review-Leiste. Kacheln laufen stumm in Schleife, sobald sie im
   Viewport stehen. Klick öffnet die Lightbox mit Ton. Kein Framework. */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
  var AUTOPLAY = !REDUCED_MOTION && !SAVE_DATA;

  function initCarousel(root) {
    if (root.dataset.dnUgcReady === 'true') return;
    root.dataset.dnUgcReady = 'true';

    var track = root.querySelector('[data-dn-ugc-track]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-dn-ugc-tile]'));
    /* Es gibt zwei Sätze Pfeile: oben rechts für den Desktop, unten für das
       Handy. Beide müssen bedienbar sein, deshalb alle einsammeln. */
    var prevButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dn-ugc-prev]'));
    var nextButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dn-ugc-next]'));
    var bar = root.querySelector('.dn-ugc__bar');
    var thumb = root.querySelector('[data-dn-ugc-thumb]');

    /* Autoplay ist bewusst gedeckelt. Shopify liefert je Video nur eine
       Auflösung von rund 10 MB, und auf einem breiten Bildschirm sind alle
       fünf Kacheln gleichzeitig sichtbar. Ohne Deckel zieht die Produktseite
       knapp 50 MB. Es laufen deshalb nur die N Kacheln, die am weitesten im
       Viewport stehen, plus die unter dem Mauszeiger. Der Rest zeigt sein
       Standbild von Shopify. */
    var maxPlaying = parseInt(root.dataset.dnUgcMaxPlaying, 10);
    if (!(maxPlaying > 0)) maxPlaying = 2;

    var ratios = [];
    var hovered = null;

    function ratioOf(video) {
      for (var i = 0; i < ratios.length; i++) {
        if (ratios[i].video === video) return ratios[i].ratio;
      }
      return 0;
    }

    function setRatio(video, ratio) {
      for (var i = 0; i < ratios.length; i++) {
        if (ratios[i].video === video) {
          ratios[i].ratio = ratio;
          return;
        }
      }
      ratios.push({ video: video, ratio: ratio });
    }

    function play(video) {
      if (!video.paused) return;
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          /* Browser verweigert Autoplay, das Standbild bleibt stehen. */
        });
      }
    }

    function applyPlayback() {
      /* Ohne Autoplay-Recht bleibt es beim Standbild. Der Aufruf nach dem
         Schließen der Lightbox darf das nicht umgehen. */
      if (!AUTOPLAY || root.dataset.dnUgcPaused === 'true') {
        tiles.forEach(function (v) {
          v.pause();
        });
        return;
      }

      /* Kandidaten sind nur die deutlich sichtbaren, nach Sichtbarkeit sortiert. */
      var kandidaten = tiles
        .filter(function (v) {
          return ratioOf(v) >= 0.5;
        })
        .sort(function (a, b) {
          return ratioOf(b) - ratioOf(a);
        })
        .slice(0, maxPlaying);

      if (hovered && kandidaten.indexOf(hovered) === -1) {
        /* Die Kachel unter dem Zeiger verdrängt die am wenigsten sichtbare. */
        if (kandidaten.length >= maxPlaying) kandidaten.pop();
        kandidaten.push(hovered);
      }

      tiles.forEach(function (v) {
        if (kandidaten.indexOf(v) !== -1) {
          play(v);
        } else {
          v.pause();
        }
      });
    }

    if (AUTOPLAY && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setRatio(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          applyPlayback();
        },
        /* Mehrere Schwellen, damit sich die Rangfolge beim Scrollen mitbewegt. */
        { threshold: [0, 0.25, 0.5, 0.75, 1] }
      );

      tiles.forEach(function (video) {
        observer.observe(video);
      });

      /* Hover nur auf Zeigergeräten, Touch hat keinen sinnvollen Hover-Zustand. */
      if (window.matchMedia('(hover: hover)').matches) {
        root.querySelectorAll('[data-dn-ugc-open]').forEach(function (card) {
          var video = card.querySelector('[data-dn-ugc-tile]');
          if (!video) return;
          card.addEventListener('mouseenter', function () {
            hovered = video;
            applyPlayback();
          });
          card.addEventListener('mouseleave', function () {
            if (hovered === video) hovered = null;
            applyPlayback();
          });
        });
      }
    }

    /* Nach dem Schließen der Lightbox die Auswahl neu bestimmen. */
    root.dnUgcApplyPlayback = applyPlayback;

    if (!track) return;

    function step() {
      var item = root.querySelector('.dn-ugc__item');
      if (!item) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || '12') || 12;
      return item.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function syncBar() {
      if (!bar || !thumb) return;
      var barWidth = bar.clientWidth;
      if (!barWidth || !track.scrollWidth) return;

      /* Der Daumen ist so breit wie der sichtbare Anteil der Reihe, mindestens
         aber 24 px, sonst verschwindet er bei vielen Kacheln. */
      var anteil = Math.min(1, track.clientWidth / track.scrollWidth);
      var thumbWidth = Math.max(24, Math.round(barWidth * anteil));
      thumb.style.width = thumbWidth + 'px';

      var max = maxScroll();
      var fortschritt = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.transform = 'translateX(' + Math.round((barWidth - thumbWidth) * fortschritt) + 'px)';
    }

    function syncArrows() {
      var max = maxScroll() - 2;
      /* Passen alle Kacheln in die Breite, braucht niemand Pfeile und Balken. */
      root.classList.toggle('dn-ugc--static', max <= 0);
      prevButtons.forEach(function (b) {
        b.disabled = track.scrollLeft <= 2;
      });
      nextButtons.forEach(function (b) {
        b.disabled = track.scrollLeft >= max;
      });
      syncBar();
    }

    function scrollUm(richtung) {
      track.scrollBy({ left: richtung * step(), behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
    }

    if (prevButtons.length || nextButtons.length || bar) {
      prevButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          scrollUm(-1);
        });
      });
      nextButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          scrollUm(1);
        });
      });
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      syncArrows();
    }
  }

  /* Der Öffner liegt im Modulscope, nicht in der Modal-Closure: der Theme-Editor
     ersetzt die Section samt <dialog>, und ein Handler mit einer Referenz auf das
     alte Element würde auf ein längst entferntes Modal schreiben. */
  var opener = null;
  var clickBound = false;

  function currentModal() {
    return document.querySelector('[data-dn-ugc-modal]');
  }

  function pauseTiles(paused) {
    document.querySelectorAll('[data-dn-ugc]').forEach(function (root) {
      if (paused) {
        root.dataset.dnUgcPaused = 'true';
        root.querySelectorAll('[data-dn-ugc-tile]').forEach(function (v) {
          v.pause();
        });
      } else {
        delete root.dataset.dnUgcPaused;
        /* Auswahl neu bestimmen, sonst bleibt die Leiste nach der Lightbox
           stehen, bis der nächste Scroll ein Observer-Event auslöst. */
        if (typeof root.dnUgcApplyPlayback === 'function') root.dnUgcApplyPlayback();
      }
    });
  }

  function openFrom(button) {
    var modal = currentModal();
    if (!modal) return;

    var player = modal.querySelector('[data-dn-ugc-player]');
    var src = button.getAttribute('data-dn-ugc-src');
    if (!src || !player) return;

    opener = button;
    /* Kachel-Videos anhalten, damit nicht zwei Tonspuren gleichzeitig laufen. */
    pauseTiles(true);

    player.src = src;
    player.muted = false;
    modal.setAttribute('aria-label', button.getAttribute('data-dn-ugc-name') || 'Creator-Video');

    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    var attempt = player.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Ohne Autoplay-Recht übernimmt der Nutzer über die Controls. */
      });
    }
  }

  function closeModal(modal) {
    if (typeof modal.close === 'function') {
      if (modal.open) modal.close();
    } else {
      modal.removeAttribute('open');
    }
    /* Nicht allein auf das close-Event warten. Räumt es doppelt auf, ist das
       harmlos, bleibt es aus, läuft sonst der Ton im Hintergrund weiter. */
    resetModal(modal);
  }

  function resetModal(modal) {
    var player = modal.querySelector('[data-dn-ugc-player]');
    if (player) {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }
    pauseTiles(false);
    if (opener && document.contains(opener) && typeof opener.focus === 'function') {
      opener.focus();
    }
    opener = null;
  }

  function initModal(modal) {
    if (!modal || modal.dataset.dnUgcReady === 'true') return;
    modal.dataset.dnUgcReady = 'true';

    var close = modal.querySelector('[data-dn-ugc-close]');
    if (close) {
      close.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    /* Klick auf den Backdrop schließt, Klick auf das Video nicht. */
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal(modal);
    });

    modal.addEventListener('close', function () {
      resetModal(modal);
    });
  }

  /* Genau einmal pro Seite, unabhängig davon wie oft Sections neu laden. */
  function bindOpeners() {
    if (clickBound) return;
    clickBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-dn-ugc-open]') : null;
      if (button) {
        event.preventDefault();
        openFrom(button);
      }
    });
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-dn-ugc]').forEach(initCarousel);
    context.querySelectorAll('[data-dn-ugc-modal]').forEach(initModal);
    bindOpeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme-Editor lädt Sections neu, ohne die Seite neu zu laden. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
